import React, { useState } from 'react';
import { FaPlusCircle } from "react-icons/fa";
import {
    Button,
    Form,
    Input,
    DatePicker,
    TimePicker,
    Select,
    Modal,
    message
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import dayjs from 'dayjs';
import axios from '../../../config/axios';


export default function FormCreateAttendance({ courses }) {

    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const redirect = useNavigate();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            axios
                .post('/api/attendance/', data)
                .then(res => {
                    // console.log(res.data);
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: 'Create successfully',
                        duration: 1,
                        onClose: () => redirect(`/admin/attendance/${res.data._id}`)
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Create failed!',
                    });
                })
        },
    });

    const onCreate = () => {
        form
            .validateFields()
            .then(values => mutate({
                ...values,
                begin_time: dayjs(values.time[0]).format("HH:mm"),
                end_time: dayjs(values.time[1]).format("HH:mm")
            }))
            .catch(err => {
                console.log(err)
                messageApi.open({
                    type: 'error',
                    content: 'Something went wrong please check you data or contact Admin.',
                });
            })
    };

    const onCancelCreate = () => {
        form.resetFields();
        setOpen(false);
    }

    return (
        <div>
            {contextHolder}
            <Button
                type='primary'
                icon={<FaPlusCircle />}
                onClick={() => setOpen(true)}
            >Add</Button>
            <Modal
                open={open}
                title="Create Attendance"
                onCancel={onCancelCreate}
                footer={[
                    <Button key="back" onClick={onCancelCreate}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" disabled={isLoading} onClick={onCreate}>
                        Ok
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name='createAttendance'
                    initialValues={{
                        check_date: dayjs()
                    }}
                >
                    <Form.Item
                        label="Date"
                        name="check_date"
                    >
                        <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                        {/* <DatePicker.RangePicker
                            showTime={{ format: 'HH:mm' }}
                            format="DD-MM-YYYY HH:mm"
                            style={{ width: "100%" }} 
                        /> */}

                    </Form.Item>
                    <Form.Item
                        label="Time"
                        name="time"
                    >
                        <TimePicker.RangePicker style={{ width: "100%" }} format={"HH:mm"} />
                    </Form.Item>
                    <Form.Item
                        label="Course"
                        name="product"
                        rules={[
                            {
                                required: true,
                                message: 'Please input data!',
                            },
                        ]}
                    >
                        <Select
                            placeholder="Select Category"
                        >
                            {
                                courses.map(course => <Select.Option key={course._id} value={course._id}>{course.name}</Select.Option>)
                            }
                        </Select>
                    </Form.Item>
                    {/* </Col>
                    </Row> */}
                    <Form.Item name="description" label="Description">
                        <Input.TextArea type="textarea" rows={2} />
                    </Form.Item>
                </Form>
            </Modal>
        </div>

    )
}
